import { useTranslation } from "@redotech/redo-i18n";
import QrCode from "@redotech/redo-icons/qr-code-01.svg";
import type { ReturnDropoff } from "@redotech/redo-model/return";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { DropoffLocationsButton } from "./dropoff-locations-button";

export const DropoffLabelButtons = memo(function DropoffLabelButtons({
  dropoffs,
  returnId,
  autoOpen = false,
}: {
  dropoffs: ReturnDropoff;
  returnId: string;
  autoOpen?: boolean;
}) {
  const { t } = useTranslation();
  const firstQrCodeUrl = dropoffs.qrCodes[0]?.qrCodeUrl;

  return (
    <Flex flexDirection="row" gap="sm">
      {!!firstQrCodeUrl && (
        <RedoButton
          hierarchy="secondary"
          IconLeading={QrCode}
          onClick={() => window.open(firstQrCodeUrl, "_blank")}
          text={t("QR code")}
        />
      )}
      <DropoffLocationsButton autoOpen={autoOpen} returnId={returnId} />
    </Flex>
  );
});
